import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { HeaderTopComponent } from '../../../app/content/layout/components/general/header/components/header-top/header-top.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<HeaderTopComponent> = {
  title: 'Organisms/Header/Header Top',
  component: HeaderTopComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'fullscreen',
    backgrounds: { default: 'dark', values: [{ name: 'dark', value: 'rgba(92, 10, 49, 0.8)' }] },
  },
};
export default meta;
type Story = StoryObj<HeaderTopComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-header-top')).toBeTruthy();
  },
};
